Common.Views.Workspace = Backbone.View.extend({
	el: 'body',
	partials: {},
	loaderTimerId: null,
	loaderPositionX: 0,
	scrollbarWidth: null,

	events: {
		'focus .ui-textbox.error .js-textbox': 'focusInvalidateFields',
		'keydown .js-field-input--numeric': 'inputNumeric',
		'input .js-field-input': 'changeFieldValue',
		'change .js-field-input': 'changeFieldValue',
		'focus .js-field-input': 'focusField',
		'blur .js-field-input': 'blurField',
		'change .js-field-file': 'changeFieldFile',
		'click .js-field-delete': 'deleteFieldFile'
	},

	initialize: function() {
		var allowedSystemKeys = [8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 46, 116],
			allowedNumericKeys = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];

		this._allowedNumericKeys = _.union(allowedSystemKeys, allowedNumericKeys);
		this._numericRegExp = /^(\d+)$/;
		this._numericInputClass = 'js-field-input--numeric';

		// Регистрируем шаблоны-паршелы UI-элементов
		Common.registerHandlebarsPartials($('.js-partials'));

		this.partials = {
			$window: $(window),
			$document: $(document),
			$html: $('html'),
			$body: this.$el,
			$modal: $('.js-modal', this.$el),
			$notify: $('.js-notify', this.$el),
			$blind: $('.js-blind', this.$el),
			$lBody: $('.js-body', this.$el),
			$lBodyWrapper: $('.js-body-wrapper', this.$el),
			$content: $('.js-content', this.$el)
		};

		this.partials.$window.on('resize.schedule_scroll', this.setLBodyWrapperBarWidthOffset.bind(this));
	},

	// Методы для прелоадеров ajax-запросов
	showPreloader: function(isNotBlind) {
		this.partials.$blind.toggleClass('g-hidden', !!isNotBlind);
	},

	hidePreloader: function() {
		this.partials.$blind.addClass('g-hidden');
	},

	animatePreloaderSpin: function ($preloaderSpin) {
		var $preloaderCircular = $preloaderSpin.find('.circular'),
			$preloaderPath = $preloaderSpin.find('.path'),
			isLoading = true;

		function rotatePreloader () {
			if (isLoading) {
				$({deg: 0}).animate({deg: 360}, {
					duration: 2000,
					step: function(now) {
						$preloaderCircular.css({
							transform: 'rotate(' + now + 'deg)',
							msTransform: 'rotate(' + now + 'deg)'
						});
					},
					easing: 'linear',
					complete: function () {
						rotatePreloader();
					}
				});
			}
		}

		function dashPreloader () {
			if (isLoading) {
				$({
					dasharray: 1,
					dashoffset: 0
				}).animate({
					dasharray: 89,
					dashoffset: -35
				}, {
					duration: 750,
					step: function(now, fx) {
						if (fx.prop === 'dasharray') {
							$preloaderPath.css({
								strokeDasharray: now + ', 200'
							});
						} else if (fx.prop === 'dashoffset') {
							$preloaderPath.css({
								strokeDashoffset: now + 'px'
							});
						}
					},
					complete: function () {
						$({
							dashoffset: -35
						}).animate({
							dashoffset: -124
						}, {
							duration: 750,
							step: function(now) {
								$preloaderPath.css({
									strokeDashoffset: now + 'px'
								});
							},
							complete: function () {
								dashPreloader();
							}
						});
					}
				});
			}
		}

		rotatePreloader();
		dashPreloader();

		return {
			stop: function () {
				isLoading = false;
			}
		};
	},

	// Метод для подсветки полей с ошибками валидации
	highlightInvalidateFields: function(errors, $form) {
		var $errorFields = $('.js-field--error', this.$el),
			errorClasses = 'b-field--error js-field--error',
			$inputs, $field;

		$errorFields.removeClass(errorClasses);

		_.each(errors.fields, function (fieldNames) {
			fieldNames = fieldNames.split(', ');

			_.each(fieldNames, function (name) {
				$inputs = $form.find('[name="' + name + '"]');

				if (!$inputs.length) {
					$inputs = $form.find('[data-name="' + name + '"]');
				}
				
				$field = $inputs.closest('.js-field');

				$field.addClass(errorClasses);
			});
		});
	},

	// Убираем подсветку ошибки при получении фокуса полем
	focusInvalidateFields: function(e) {
		$(e.currentTarget)
			.closest('.ui-textbox')
			.removeClass('error');
	},

	changeFieldValue: function (e) {
		var $input = $(e.currentTarget),
			$field = $input.closest('.js-field'),
			val;

		if ($input.is('[contenteditable]')) {
			val = $.trim($input.html());

			if (val === '<br>') {
				val = '';
				$input.html(val);
			}

			$input.prev('input[type="hidden"]').val(val);
		} else {
			val = $.trim($input.val());

			if ($input.hasClass(this._numericInputClass) && !this._numericRegExp.test(val)) {
				$input.val('');
				val = $input.val();
			}
		}

		$field
			.toggleClass('b-field--value', !!val)
			.toggleClass('b-field--empty', !val)
			.removeClass('b-field--error js-field--error');
	},

	focusField: function (e) {
		var $input = $(e.currentTarget),
			$field = $input.closest('.js-field');

		if (!$input.prop('readonly') && !$input.prop('disabled')) {
			$field.addClass('b-field--focus');
		}
	},

	blurField: function (e) {
		var $input = $(e.currentTarget),
			$field = $input.closest('.js-field');

		this.changeFieldValue(e);

		if ($input.hasClass('js-mask')) {
			setTimeout(function () {
				this.changeFieldValue(e);
			}.bind(this));
		}

		$field.removeClass('b-field--focus');
	},

	changeFieldFile: function (e) {
		var $file = $(e.currentTarget),
			$field = $file.closest('.js-field'),
			$description = $field.find('.js-field-description'),
			$input = $field.find('.js-field-input'),
			$upload = $field.find('.js-field-upload'),
			$delete = $field.find('.js-field-delete'),
			file = e.currentTarget.files && e.currentTarget.files[0],
			hiddenClass = 'g-hidden',
			errorClass = 'b-field--error js-field--error',
			requiredExtensions,
			extension,
			requiredExtensionsMessage;

		$field.removeClass(errorClass);
		$description.empty();
		$file.removeProp('isInvalidExtesion');

		if (file) {
			$input
				.val(file.name)
				.trigger('change');

			requiredExtensions = $file.data('ext');

			if (requiredExtensions) {
				extension = file.name.match(/\.[^.]+$/i)[0];
				requiredExtensions = requiredExtensions.split(', ');

				if (requiredExtensions.indexOf(extension) === -1) {
					$field.addClass(errorClass);
					$file.prop('isInvalidExtesion', true);

					requiredExtensionsMessage = $file.data('ext_message');

					if (requiredExtensionsMessage) {
						$description.text(requiredExtensionsMessage);
					}
				}
			}
		} else {
			$input
				.val('')
				.trigger('change');
		}

		$upload.addClass(hiddenClass);
		$delete.addClass(hiddenClass);

		$upload.toggleClass(hiddenClass, !!file);
		$delete.toggleClass(hiddenClass, !file);
	},

	deleteFieldFile: function (e) {
		var $button = $(e.currentTarget),
			$field = $button.closest('.js-field'),
			$file = $field.find('.js-field-file');

		$file
			.val(null)
			.trigger('change');
	},

	// Метод для установки курсора внутри текстовых полей в произвольную позицию
	setInputCursor: function(element, position) {
		if (element.createTextRange) {
			var textRange = element.createTextRange();

			textRange.collapse(true);
			textRange.moveEnd('character', position);
			textRange.moveStart('character', position);
			textRange.select();
			return true;
		} else if (element.setSelectionRange) {
			element.setSelectionRange(position, position);
			return true;
		}

		return false;
	},

	// Метод, отображающий стандартный нотификатор с сообщением об ошибке
	showNotificator: function(errors, title, type, isHTML, viewName) {
		Common.get(viewName || 'Notify').view.show({
			type: type,
			title: title,
			message: (errors && errors.messages) ? errors.messages.join('. ') : errors,
			isHTML: isHTML
		});
	},

	showDetailedNotificator: function(errors, title, type, isHTML) {
		this.showNotificator.apply(this, [errors, title, type, isHTML, 'DetailedNotify']);
	},

	downloadFile: function (url, params) {
		var xhr = new XMLHttpRequest();

		xhr.startTime = new Date().getTime();
		params = params || {};

		xhr.open(params.httpMethod || 'get', url, true);
		xhr.responseType = 'arraybuffer';
	
		xhr.onload = function () {
			var reader = new FileReader();

			if (this.status === 401) {
				Common.view.showNotificator('Ваша сессия истекла. Недостаточно прав для доступа к странице');

				setTimeout(function() {
					Common.router.index();
					location.reload();
				}, 3000);
			} else if (this.status === 200) {
				var filename = '',
					disposition = xhr.getResponseHeader('Content-Disposition');

				if (disposition && disposition.indexOf('attachment') !== -1) {
					var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
						matches = filenameRegex.exec(disposition);

					if (matches && matches[1]) {
						filename = matches[1].replace(/['"]/g, '');
					}
				}

				var blob = new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') }),
					isFail = false;

				if (typeof window.navigator.msSaveBlob !== 'undefined') {
					// IE workaround for "HTML7007"
					if (filename) {
						window.navigator.msSaveBlob(blob, filename);
					} else {
						isFail = true;
						reader.readAsText(blob);

						reader.onloadend = function () {
							if (params.failCallback) {
								params.failCallback(reader.result, url);
							}
						};
					}
				} else {
					var URL = window.URL || window.webkitURL,
						downloadUrl = URL.createObjectURL(blob);

					if (filename) {
						// use HTML5 a[download] attribute to specify filename
						var a = document.createElement('a');

						// safari doesn't support this yet
						if (typeof a.download === 'undefined') {
							window.location = downloadUrl;
						} else {
							a.href = downloadUrl;
							a.download = filename;
							document.body.appendChild(a);
							a.click();
						}
					} else {
						isFail = true;
						reader.readAsText(blob);

						reader.onloadend = function () {
							if (params.failCallback) {
								params.failCallback(reader.result, url);
							}
						};
					}

					setTimeout(function () {
						URL.revokeObjectURL(downloadUrl);
					}, 100); // cleanup
				}

				if (!isFail) {
					if (params.successCallback) {
						params.successCallback(url);
					}
				}
			} else {
				reader.readAsText(new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') }));

				reader.onloadend = function () {
					if (params.failCallback) {
						params.failCallback(reader.result, url);
					}
				};
			}
		};

		xhr.onerror = function () {
			var reader = new FileReader();

			reader.readAsText(new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') }));

			reader.onloadend = function () {
				if (params.failCallback) {
					params.failCallback(reader.result, url);
				}
			};
		};

		xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		xhr.send((params && params.data) ? $.param(params.data) : null);
	},

	getScrollbarWidth: function () {
		if (!this.scrollbarWidth) {
			var div = $('<div style="width:50px;height:50px;overflow:hidden;position:absolute;' +
						'top:-200px;left:-200px;"><div style="height:100px;"></div></div>');

			$('body').append(div);

			var $div = $('div', div),
				w1 = $('div', div).innerWidth();

			div.css('overflow-y', 'scroll');
			$div.css('position', 'relative');

			var w2 = $div.innerWidth();

			$(div).remove();
			this.scrollbarWidth = w1 - w2;
		}

		return this.scrollbarWidth;
	},

	toggleFieldDisableState: function ($field, isDisabled) {
		var $input = $field
			.toggleClass('b-field--disabled', isDisabled)
			.find('input')
			.prop('disabled', isDisabled);

		if (isDisabled) {
			$input.val('');
			$field.removeClass('b-field--value');
		}
	},

	setLBodyWrapperBarWidthOffset: function () {
		if (this.partials.$lBody.innerHeight() < this.partials.$lBodyWrapper.outerHeight()) {
			this.partials.$lBodyWrapper.css('marginRight', -this.getScrollbarWidth());
		} else {
			this.partials.$lBodyWrapper.css('marginRight', 0);
		}
	},

	preventEvent: function(e) {
		e.stopPropagation();
		e.cancelBubble = true;
	}
});
